module.exports = __webpack_public_path__ + "img/brasao.cdef748a.svg";